var _excluded = ["payloadValidator", "request"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
import { request as baseRequest } from "@xo-union/fetch-request-builder";
import configure from "./configure/index.js";
import validatePayload from "../validations/index.js";
import ResponseWrapper from "./responseWrappers/responseWrapper/index.js";
var _request = /*#__PURE__*/new _WeakMap();
var _payloadValidator = /*#__PURE__*/new _WeakMap();
var _wrapper = /*#__PURE__*/new _WeakMap();
var MembershipClient = /*#__PURE__*/function () {
  function MembershipClient() {
    _classCallCheck(this, MembershipClient);
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref7$payloadValidato = _ref7.payloadValidator,
      payloadValidator = _ref7$payloadValidato === void 0 ? validatePayload : _ref7$payloadValidato,
      _ref7$request = _ref7.request,
      request = _ref7$request === void 0 ? baseRequest : _ref7$request,
      config = _objectWithoutProperties(_ref7, _excluded);
    _classPrivateFieldInitSpec(this, _request, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _payloadValidator, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _wrapper, {
      writable: true,
      value: void 0
    });
    var clientConfig = configure(config);
    var host = clientConfig.host,
      apiKey = clientConfig.apiKey;
    _classPrivateFieldSet(this, _wrapper, new ResponseWrapper(config));
    _classPrivateFieldSet(this, _payloadValidator, payloadValidator);
    _classPrivateFieldSet(this, _request, request.host(host).query({
      apikey: apiKey
    }).set('Accept-Version', 'v2'));
  }
  _createClass(MembershipClient, [{
    key: "createMember",
    value: function createMember(params) {
      _classPrivateFieldGet(this, _payloadValidator).call(this, params);
      return _classPrivateFieldGet(this, _request).post('/members').set('Content-Type', 'application/json').send({
        members: params
      }).readJsonBody().mapResponse(_classPrivateFieldGet(this, _wrapper).wrapCreateMemberRespose).mapResponse(_classPrivateFieldGet(this, _wrapper).wrapAnalyticsProperties).mapError(_classPrivateFieldGet(this, _wrapper).wrapError);
    }
  }, {
    key: "createSession",
    value: function createSession(params) {
      return _classPrivateFieldGet(this, _request).post('/sessions').set('Content-Type', 'application/json').send({
        sessions: params
      }).readJsonBody().mapResponse(_classPrivateFieldGet(this, _wrapper).wrapCreateSessionResponse).mapResponse(_classPrivateFieldGet(this, _wrapper).wrapAnalyticsProperties).mapError(_classPrivateFieldGet(this, _wrapper).wrapError);
    }
  }, {
    key: "isLoggedIn",
    value: function isLoggedIn() {
      var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        token = _ref8.token;
      return _classPrivateFieldGet(this, _request).head('/sessions').set('MEMBERSHIP-SESSION-TOKEN', token);
    }
  }, {
    key: "getMember",
    value: function getMember(_ref) {
      var token = _ref.token;
      return _classPrivateFieldGet(this, _request).get('/members').set('MEMBERSHIP-SESSION-TOKEN', token).readJsonBody().mapResponse(_classPrivateFieldGet(this, _wrapper).wrapMemberResponse(token)).mapError(_classPrivateFieldGet(this, _wrapper).wrapError);
    }
  }, {
    key: "updateMember",
    value: function updateMember(_ref2) {
      var token = _ref2.token,
        member = _ref2.member;
      _classPrivateFieldGet(this, _payloadValidator).call(this, member);
      return _classPrivateFieldGet(this, _request).patch('/members').set('MEMBERSHIP-SESSION-TOKEN', token).set('Content-Type', 'application/json').send({
        members: member
      }).readJsonBody().mapResponse(_classPrivateFieldGet(this, _wrapper).wrapMemberResponse(token)).mapError(_classPrivateFieldGet(this, _wrapper).wrapError);
    }
  }, {
    key: "deleteSession",
    value: function deleteSession(_ref3) {
      var token = _ref3.token;
      return _classPrivateFieldGet(this, _request).del('/sessions').set('MEMBERSHIP-SESSION-TOKEN', token);
    }
  }, {
    key: "changePassword",
    value: function changePassword(_ref4) {
      var token = _ref4.token,
        member = _ref4.member;
      _classPrivateFieldGet(this, _payloadValidator).call(this, member);
      return _classPrivateFieldGet(this, _request).put('/members/change_password').set('MEMBERSHIP-SESSION-TOKEN', token).set('Content-Type', 'application/json').send(member).readJsonBody().mapResponse(_classPrivateFieldGet(this, _wrapper).wrapMemberResponse(token)).mapError(_classPrivateFieldGet(this, _wrapper).wrapError);
    }
  }, {
    key: "deactivate",
    value: function deactivate(_ref5) {
      var token = _ref5.token;
      return _classPrivateFieldGet(this, _request).patch('/members/deactivate').set('MEMBERSHIP-SESSION-TOKEN', token).readJsonErrorBody().mapError(_classPrivateFieldGet(this, _wrapper).wrapError);
    }
  }, {
    key: "sendResetPasswordLink",
    value: function sendResetPasswordLink(_ref6) {
      var email = _ref6.email;
      return _classPrivateFieldGet(this, _request).post('/members/send_reset_password_link').set('Content-Type', 'application/json').send({
        email: email
      }).readJsonErrorBody().mapError(_classPrivateFieldGet(this, _wrapper).wrapError);
    }
  }, {
    key: "resetPasswordTokens",
    value: function resetPasswordTokens(params) {
      return _classPrivateFieldGet(this, _request).patch('/members/reset_password_tokens').set('Content-Type', 'application/json').send(params).readJsonErrorBody().mapError(_classPrivateFieldGet(this, _wrapper).wrapError);
    }
  }, {
    key: "validResetPasswordToken",
    value: function validResetPasswordToken(resetPasswordToken) {
      return _classPrivateFieldGet(this, _request).get("/members/reset_password_tokens/".concat(resetPasswordToken)).readJsonErrorBody().mapError(_classPrivateFieldGet(this, _wrapper).wrapError);
    }
  }]);
  return MembershipClient;
}();
export { MembershipClient as default };